import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/HomePage/techstackcomponents/TechStack.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/HomePage/Testimonials.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/jamstackcomponent/MediumBox.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/NudgeCard.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/lib/svg_renderer.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
